import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/favikon%20logo%202.jpg/:/rs=h:75,cg:true,m/qt=q:95"
              alt="IndyaNet"
              className="h-12 mb-4 bg-white rounded px-2 py-1"
            />
            <p className="text-gray-400 text-sm mb-4">
              Empowering businesses with high-performance, secure, and scalable Enterprise Network Solutions.
            </p>
            <div className="flex space-x-3 flex-wrap gap-y-3">
              <a
                href="https://www.facebook.com/703699026160151"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="bg-gray-800 hover:bg-blue-600 text-gray-300 hover:text-white p-2 rounded-full transition-colors"
              >
                <Facebook className="h-5 w-5" />
              </a>

              {/* Instagram - Will be added later

              <a
                href="https://www.instagram.com/indyanet/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="bg-gray-800 hover:bg-pink-600 text-gray-300 hover:text-white p-2 rounded-full transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>

              */}
              
              <a
                href="https://www.pinterest.com/Indyanet/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Pinterest"
                className="bg-gray-800 hover:bg-red-600 text-gray-300 hover:text-white p-2 rounded-full transition-colors"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/indyanet"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="bg-gray-800 hover:bg-blue-700 text-gray-300 hover:text-white p-2 rounded-full transition-colors"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a
                href="https://wa.me/917411954841?text=Hello%20IndyaNet%20Support"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="bg-gray-800 hover:bg-green-600 text-gray-300 hover:text-white p-2 rounded-full transition-colors"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/our-product" className="text-gray-400 hover:text-white transition-colors">
                  Our Product
                </Link>
              </li>
              <li>
                <Link to="/secure-sd-wan" className="text-gray-400 hover:text-white transition-colors">
                  Secure SD-WAN
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="text-gray-400 hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/raise-service-request" className="text-gray-400 hover:text-white transition-colors">
                  Raise Service Request
                </Link>
              </li>
              <li>
                <Link to="/track-request" className="text-gray-400 hover:text-white transition-colors">
                  Track Request
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <p className="text-xl font-bold text-white mb-3">Madilu Retail Private Limited</p>
            <div className="space-y-2 text-sm text-gray-400">
              <p>No.591, 2nd Floor, 14th Main Road,</p>
              <p>15th Cross Rd, 4th Sector, HSR Layout,</p>
              <p>Bengaluru, Karnataka 560102</p>
              <p className="mt-3">
                <a href="tel:+917411954841" className="hover:text-white transition-colors">
                  +91 7411954841
                </a>
              </p>
              <p>
                <a href="mailto:support@indyanet.com" className="hover:text-white transition-colors">
                  support@indyanet.com
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <p>Copyright © 2026 Madilu Retail Private Limited - All Rights Reserved.</p>
            <div className="flex space-x-4 mt-4 md:mt-0">
              <Link to="/terms-and-conditions" className="hover:text-white transition-colors">
                Terms and Conditions
              </Link>
              <Link to="/privacy-policy" className="hover:text-white transition-colors">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
